import { getPanelToken } from "./auth/AuthActions.js";
import store from "./index.js";

function fetchAPI(url, init) {
    return fetch(`/api/${url}`, init)
        .then(resp => {
            //Check for backend down.
            if(resp.status == 502){
                throw new Error("Server currently unavailable.");
            }else{
                return resp;
            }
        })
        .then(resp => {
            return resp.json()
                .then(data => {
                    if (resp.ok) {
                        return data;
                    } else {
                        throw new Error(data.err || `Status code ${resp.status} ${resp.statusText} returned by server.`);
                    }
                },
                err => {
                    console.error("FAILED PARSING RESPONSE BODY", err);
                    throw new Error(`Status code ${resp.status} ${resp.statusText} returned by server with invalid body.`);
                })
        },
        err => {
            throw new Error("Could not contact server due to: " + err.toString());
        });
}

export default function APICall(url, body = null, headers = {}, auth = "NONE") {

    let ourHeaders = {};
    let ourBody = undefined;
    if (auth != "NONE") {
        if (store.getState().auth[auth]) {
            ourHeaders["Authorization"] = `Bearer ${store.getState().auth[auth]}`;
        } else {
            throw new Error("Cannot find claim " + auth);
        }
    }

    if (body != null) {
        ourBody = JSON.stringify(body);
        ourHeaders["content-type"] = "application/json";
    }

    return fetchAPI(url, {
        method: ourBody == undefined ? "GET" : "POST",
        body: ourBody,
        headers: Object.assign({}, headers, ourHeaders)
    })
}
if(process.env.NODE_ENV === "development"){ // eslint-disable-line no-undef
    window._APICall = APICall;
    console.log("APICall exposed as _APICall");
}

export const dispatchAPICall = (url, body = null, headers = {}, auth = "NONE") => {
    return async dispatch => {
        await dispatch(getPanelToken());
        return APICall(url, body, headers, auth);
    }
}

export const dispatchClaimsAPICall = (url, body = null, headers = {}) => dispatchAPICall(url, body, headers, "claims");